import { formatScheduleRunWindowLabel } from "./scheduleRunWindow";
import { formatTagMatchLabel, isTagMatchValue } from "./automationTagMatch";

const UNIT_LABELS = {
  minutes: "minuto(s)",
  minutos: "minuto(s)",
  hours: "hora(s)",
  horas: "hora(s)",
  days: "dia(s)",
  dias: "dia(s)",
};

export function isScheduleIntervalValue(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  if (!Object.prototype.hasOwnProperty.call(value, "value")) return false;
  const unit = String(value.unit || "").toLowerCase();
  return Object.prototype.hasOwnProperty.call(UNIT_LABELS, unit);
}

export function formatScheduleIntervalLabel(si) {
  if (si == null || si === "") return "";
  if (typeof si !== "object") {
    const n = Number(si);
    if (!Number.isFinite(n) || n <= 0) return String(si);
    return `${n} minuto(s)`;
  }
  const val = si.value;
  if (val == null || val === "") return "";
  const unit = String(si.unit || "minutes").toLowerCase();
  const unitPt = UNIT_LABELS[unit] || "minuto(s)";
  return `${val} ${unitPt}`;
}

/** Evita Chip/Tooltip renderizarem `{ value, unit }` como `[object Object]`. */
export function formatAutomationDisplayValue(value) {
  if (value == null || value === "") return "";
  if (Array.isArray(value)) {
    return value.map(formatAutomationDisplayValue).filter(Boolean).join(", ");
  }
  if (typeof value === "object") {
    if (isScheduleIntervalValue(value)) return formatScheduleIntervalLabel(value);
    if (isTagMatchValue(value)) return formatTagMatchLabel(value);
    if (
      value.mode === "24h" ||
      value.mode === "business_hours" ||
      value.mode === "defined_schedule"
    ) {
      return formatScheduleRunWindowLabel(value);
    }
    return "";
  }
  const s = String(value);
  return s === "[object Object]" ? "" : s;
}
